import { getCompaniesTax } from "../utils/WordExportUtils";
import { addTableSpace, generateTable } from "./utils";

export const generateDTRTable = () => {
  const companyRows = getCompaniesTax();

  const columns = [
    { title: "Company Name", metric: "company_name" },
    { title: "Currency", metric: "currency" },
    {
      title: "Credit for foreign tax claimed under s18(2) TIOPA 2010",
      metric: "net_dtr_adjustment_lc",
      type: "number",
    },
    {
      title: "Tax-EBITDA adjustment",
      metric: "s407_relief_dtr_adjustment_tax_rate_equal_uk",
      type: "number",
    },
    {
      title: "Tax-Interest income adjustment",
      metric: "tax_interest_income_adjustment",
      type: "number",
    },
  ];

  const table = generateTable(companyRows, columns, [
    "net_dtr_adjustment_lc",
    "s407_relief_dtr_adjustment_tax_rate_equal_uk",
    "tax_interest_income_adjustment",
  ]);

  return [...(table ? [addTableSpace(100), table] : [])];
};
